<div class="page-container">
	<!-- sidebar is desktop only -->
	<login-sidebar [tagLine]="tagLine"></login-sidebar>

	<!-- extra div parent without padding for equal spread flex children -->
	<div class="no-padding-container">
		<div class="content-container">
			<div class="header">
				<div class="header-logo-tablet">
					<img class="logo" src="/resources/img/logo/logo_blue.svg" alt="logo" />
				</div>
				<div class="header-buttons">
					<bb-button theme="rb" backgroundColor="red" (click)="contactUs()">{{ "CONTACT_US" | translate }}</bb-button>
				</div>
			</div>
			
			<div class="login-outlet">
				<login-user [hidden]="currentPage !== 'login'" [tagLine]="tagLine"></login-user>
				<login-forgot-password *ngIf="currentPage === 'login/forgot-password'"></login-forgot-password>
				<login-choose-publication *ngIf="currentPage === 'login/show-publications'"></login-choose-publication>
				<login-reset-password *ngIf="currentPage === 'login/reset-password'"></login-reset-password>
			</div>
			
			<login-footer (dataProtectionClick)="showAbout()"></login-footer>
		</div>
	</div>
</div>
